import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ReactMarkdown from 'react-markdown'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import Icon from '../../../../components/atoms/Icon'

const useStyles = makeStyles((theme) => ({
  thoughtBlock: {
    marginTop: 'var(--margin-sm)',
    marginBottom: 'var(--margin-xs)',
    borderRadius: '8px',
    overflow: 'hidden'
  },
  thoughtHeader: {
    padding: 'var(--padding-xs) 0',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  thoughtType: {
    fontSize: 'var(--font-size-xs)',
    fontWeight: 'var(--font-weight-normal)',
    color: 'var(--dai-color-text)',
    flex: 1
  },
  thoughtTimestamp: {
    fontSize: 'var(--font-size-xs)',
    color: 'var(--day-color-text)',
    fontWeight: 'normal'
  },
  thoughtContent: {
    borderTop: 'var(--dai-border1)',
    backgroundColor: 'var(--dai-color-surface2)',
    padding: 'var(--padding-sm)',
    fontSize: 'var(--font-size-xs)',
    lineHeight: 1.6,
    color: 'var(--dai-color-text)',
    fontWeight: 'var(--font-weight-light)',
    '& p': {
      margin: '0 0 8px 0',
      '&:last-child': { margin: 0 }
    },
    '& code': {
      backgroundColor: 'var(--dai-color-bg-inline)',
      padding: '2px 6px',
      borderRadius: '4px',
      fontSize: '12px',
      fontFamily: 'var(--font-family-monospace)'
    },
    '& pre': {
      backgroundColor: 'var(--dai-color-bg-inline)',
      padding: 'var(--padding-sm)',
      borderRadius: '6px',
      overflow: 'auto',
      margin: '8px 0',
      '& code': {
        backgroundColor: 'transparent',
        padding: 0
      }
    }
  }
}))

function ThoughtBlock ({ eventId, type, subType, name, data, timestamp, defaultExpanded = false }) {
  const classes = useStyles()
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  return (
    <FadeIn className='font-sans radius-md select-none'>
      <div
        className={classes.thoughtHeader}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Icon
          name='infoOutlined'
          customSize='16px'
        />
        <span className={classes.thoughtType}>
          {name}
        </span>
      </div>
      {isExpanded ? (
        <FadeIn className={classes.thoughtContent}>
          <ReactMarkdown>{data?.content}</ReactMarkdown>
        </FadeIn>
      ) : null}
    </FadeIn>
  )
}

ThoughtBlock.propTypes = {
  eventId: PropTypes.string.isRequired,
  type: PropTypes.string,
  subType: PropTypes.string,
  name: PropTypes.string,
  data: PropTypes.shape({
    content: PropTypes.string.isRequired
  }),
  timestamp: PropTypes.string.isRequired,
  defaultExpanded: PropTypes.bool
}

export default ThoughtBlock
